var number_of_slides = 0;

$(document).ready(function() {

    todays_date = new Date();
    if ($("#consent_signed_date").val() == undefined) {
        todays_date = new Date($("#consent_signed_date").val());
    }
    $('.today_date').val((todays_date.getMonth() + 1) + '/' + todays_date.getDate() + '/' + todays_date.getFullYear());
    $('.slider-next-select').on('change', function (event) {
        var answer_text = $(this).text();
        if(answer_text.includes("boy")){
            replace_child_gender(true);
        }
        else if (answer_text.includes("girl")){
            replace_child_gender(false);
        }
    });

    $('.questionnaire-content-label').each(function(){
        if($(this).text().includes("What is your child’s gender identity?")) {
            $(this).parent().find('.slider-next-select').on('change', function (event) {
                if ($(this).data('answer') !== "Man") {
                    let pronoun = "their";
                    if ($(this).data('answer') == "Woman") {
                        pronoun = "her";
                    }
                    return fix_pronoun(pronoun);
                }
            });
        }
    });

    function fix_pronoun(pronoun) {
        $('.questionnaire-content-label').each(function(){
            if($(this).text().includes("Where does your child live?")) {
                $(this).parent().find('.slider-next-select').each(function(){
                    if($(this).text().includes(' his ')) {
                        $(this).html($(this).html().replace(' his ', ' ' + pronoun + ' '));
                    }
                });
            }
        });
    }

    function replace_child_gender(is_boy){
        var replacement = "son";
        if(!is_boy){
            replacement = "daughter";
        }
        $('.questionnaire-content-label').each(function(){
            if($(this).text().includes('child')) {
                $(this).html($(this).html().replace('child', replacement));
            }
        });
        replacement = "his";
        if(!is_boy){
            replacement = "her";
        }
        $('label.slider-next-select').each(function(){
            if($(this).text().includes('his/her')) {
                $(this).html($(this).html().replace('his/her', replacement));
            }
        });
    }

    $("#country_id").on('change', function (event) {
        if ($("#country_id").val() != 1) {
            $("#state_id").val(0);
            $(".state-select").hide(400);
        } else {
            $(".state-select").show(400);
        }
    });

    $("#same_address_as_child").change(function(){
       if(this.checked){
           $("#consent_school_parent_parent_address1").val($("#consent_school_parent_teen_address1").val());
           $("#consent_school_parent_parent_address2").val($("#consent_school_parent_teen_address2").val());
           $("#consent_school_parent_parent_city").val($("#consent_school_parent_teen_city").val());
           $("#consent_school_parent_parent_zip").val($("#consent_school_parent_teen_zip").val());
           $("#parent_state_select").val($("#teen_state_select").val());
           $("#parent_country_select").val($("#teen_country_select").val());
           show_state_parent_consent('parent');
       }
    });

    if (!!page_info.features.parent_child_account) {
        show_state_parent_consent('parent');
        show_state_parent_consent('teen');

        $("#teen_country_select").bind('change', function() {
            show_state_parent_consent('teen');
        });

        $("#parent_country_select").bind('change', function() {
            show_state_parent_consent('parent');
        });

        function show_state_parent_consent(section) {
            if (section == 'parent') {
                if ($("#parent_country_select").val() == 1) {
                    $("#parent_state_select").prop('required', true);
                    $("#div_parent_state").removeClass('hide');
                    $("#label_parent_zip").text('Zip');
                } else {
                    $("#parent_state_select").prop('required', false);
                    $("#div_parent_state").addClass('hide');
                    $("#label_parent_zip").text('Postal Code');
                }
            } else {
                if ($("#teen_country_select").val() == 1) {
                    $("#teen_state_select").prop('required', true);
                    $("#div_teen_state").removeClass('hide');
                    $("#label_teen_zip").text('Zip');
                } else {
                    $("#teen_state_select").prop('required', false);
                    $("#div_teen_state").addClass('hide');
                    $("#label_teen_zip").text('Postal Code');
                }
            }
        }
    }
    //## For TC 'How it Works' infographic
    function hideInfographicAndMobileLoginAfterFirstQuestion () {
        if( parseInt($(".slick-active").attr("data-slick-index")) != 0 || isNaN(parseInt($(".slick-active").attr("data-slick-index")) ) === true ) {
            $(".test-infographic-container-one, #infographic-container-two, #infographic").slideUp(500, "easeInOutCubic");
            $(".funnel-login-link").removeClass("visible-xs").hide();
        }
    }

    $("#start-form, button[id*='dont']").on("click", function(){
        // setTimeout to ensure DOM is queried AFTER user submits valid response to first question, and infographic removed.
        setTimeout(hideInfographicAndMobileLoginAfterFirstQuestion, 0);
    });
    // initial call to function on page load, e.g after submission of questionnaire
    hideInfographicAndMobileLoginAfterFirstQuestion();

    // start of chevron animation for infographic
    if(page_info.product_code_name === "betterhelp" || page_info.product_code_name === "teencounseling" ) {
        $("input").on("click", function(){
            $("#infographic-carousel-bh, #infographic-carousel-tc").hide();
        });

        number_of_slides = $(".carousel-indicators li").length - 1;

        function get_active_tab() {
            var active_tab;
            $(".carousel-indicators li").each(function(i,e) {
                if($(e).hasClass("active")){
                    active_tab = parseInt(i, 10);
                }
            });
            return active_tab;
        }

        var left_chevron = $(".fa-chevron-left ");
        var left_chevron_anchor_element = $(".left");
        var right_chevron = $(".fa-chevron-right ");
        var right_chevron_anchor_element = $(".right");

        $("#infographic-carousel-bh, #infographic-carousel-tc").on("click", function() {
            setTimeout( function() {
                if (get_active_tab() === 0) {
                    right_chevron_anchor_element.removeClass("hidden");
                    left_chevron_anchor_element.addClass("hidden");
                } else if (get_active_tab()> 0 && get_active_tab() < number_of_slides) {
                    left_chevron_anchor_element.removeClass("hidden");
                    right_chevron_anchor_element.removeClass("hidden");
                } else {
                    left_chevron_anchor_element.removeClass("hidden");
                    right_chevron_anchor_element.addClass("hidden");
                }
            }, 50);
            // To restart animations in sync after user click (2-part process: 1st part)
        });

        $(".carousel-control").on("click", function() {
            $("#infographic-carousel-bh, #infographic-carousel-tc").trigger("click");
        });

        $(".carousel").on("touchstart", function(event){
            var xClick = event.originalEvent.touches[0].pageX;
            $(".carousel").one("touchmove", function(event){
                var xMove = event.originalEvent.touches[0].pageX;

                if( (get_active_tab() >= 0 && get_active_tab() < number_of_slides) && Math.floor(xClick - xMove) > 0 ){
                    $(this).carousel('next');
                }
                else if( (get_active_tab() > 0 && get_active_tab() <= number_of_slides) && Math.floor(xClick - xMove) < -2 ){
                    $(this).carousel('prev');
                }
            });
            $(".carousel").on("touchend", function(){
                $(this).off("touchmove");
                $("#infographic-carousel-bh, #infographic-carousel-tc").trigger("click"); // Hack, to update infographic logic
            });
        });
    }
    // end of chevron animation for TC infographic
    //## End: TC 'How it Works' infographic
});
